import { Applicant, FormValue } from '@flatsy/types/Applications'
import { APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'
import i18n from '@flatsy/utils/translations'
import { Options as ButtonsOptions } from '@flatsy/core/Form/ReactFormHooks/Field/Buttons/Type'

export const renderSituation = (applicant: Applicant | undefined): string => {
  if (applicant?.kind === APPLICANT_KIND.co_applicant) {
    return i18n.t('what_is_your_co_signer_status')
  }
  if (applicant?.kind === APPLICANT_KIND.guarantor) {
    return i18n.t('what_is_the_guarantor_situation')
  }
  return i18n.t('what_is_your_situation')
}

export const renderActivity = (applicant: Applicant | undefined): string => {
  if (
    applicant?.kind === APPLICANT_KIND.co_applicant ||
    applicant?.kind === APPLICANT_KIND.guarantor
  ) {
    return i18n.t('what_is_his_or_her_activity')
  }
  return i18n.t('what_type_of_contract_do_you_have')
}

export const renderPeriod = (applicant: Applicant | undefined): string => {
  if (
    applicant?.kind === APPLICANT_KIND.co_applicant ||
    applicant?.kind === APPLICANT_KIND.guarantor
  ) {
    return i18n.t('is_he_in_trial_period_do_you_have_a_job_offer')
  }
  return i18n.t('are_you_in_trial_period_do_you_have_a_job_offer')
}

export const renderUnemployment = (applicant: Applicant | undefined): string => {
  if (
    applicant?.kind === APPLICANT_KIND.co_applicant ||
    applicant?.kind === APPLICANT_KIND.guarantor
  ) {
    return i18n.t('is_he_or_she_on_unemployment_or_welfare')
  }
  return i18n.t('are_you_on_unemployment_or_welfare')
}

export const renderLabelRevenu = (applicant: Applicant | undefined): string => {
  if (applicant?.kind === APPLICANT_KIND.main) {
    return i18n.t('your_monthly_income_before_tax')
  }
  return i18n.t('his_or_her_monthly_income_before_tax')
}

export const renderLabelUnemployement = (applicant: Applicant | undefined): string => {
  if (applicant?.kind === APPLICANT_KIND.main) {
    return i18n.t('remaining_time_on_your_unemployment')
  }
  return i18n.t('remaining_time_on_his_unemployment')
}

export const renderLabelRevenuReference = (applicant: Applicant | undefined): string => {
  if (applicant?.kind === APPLICANT_KIND.main) {
    return i18n.t('your_personal_annual_tax_return')
  }
  return i18n.t('his_or_her_personal_annual_tax_return')
}

export const renderLabelDuration = (applicant: Applicant | undefined): string | undefined => {
  if (applicant?.kind === APPLICANT_KIND.main) {
    return i18n.t('remaining_contract_time')
  }
}

export const renderProSituation = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('employed'),
      value: FormValue.proSituation.EMPLOYED,
    },
    {
      label: i18n.t('self_employed'),
      value: FormValue.proSituation.UNEMPLOYED,
    },
    {
      label: i18n.t('retired'),
      value: FormValue.proSituation.RETIRED,
    },
    {
      label: i18n.t('student'),
      value: FormValue.proSituation.STUDENT,
    },
    {
      label: i18n.t('unemployed'),
      value: FormValue.proSituation.WITHOUT_ACTIVITY,
    },
  ]
}

export const renderProSituationGarant = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('employed'),
      value: FormValue.proSituation.EMPLOYED,
    },
    {
      label: i18n.t('self_employed'),
      value: FormValue.proSituation.UNEMPLOYED,
    },
    {
      label: i18n.t('retired'),
      value: FormValue.proSituation.RETIRED,
    },
    {
      label: i18n.t('unemployed'),
      value: FormValue.proSituation.WITHOUT_ACTIVITY,
    },
  ]
}

export const renderTrialOrEmployed = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('no'),
      value: FormValue.proStatus.CDI,
    },
    {
      label: i18n.t('yes'),
      value: FormValue.proStatus.CDI_PROBATION,
    },
  ]
}

export const renderProStatus = (text: string): ButtonsOptions[] => {
  switch (text) {
    case FormValue.proSituation.EMPLOYED:
      return [
        {
          label: i18n.t('permanent_contract'),
          value: FormValue.proStatus.CDI,
        },
        {
          label: i18n.t('fixed_term_contract'),
          value: FormValue.proStatus.CDD,
        },
        {
          label: i18n.t('civil_servant'),
          value: FormValue.proStatus.CIVIL_SERVANT,
        },
      ]
    case FormValue.proStatus.CDI_PROBATION:
      return [
        {
          label: i18n.t('trial_period'),
          value: FormValue.proStatus.CDI_PROBATION,
        },
        {
          label: i18n.t('fixed_term_contract'),
          value: FormValue.proStatus.CDD,
        },
        {
          label: i18n.t('civil_servant'),
          value: FormValue.proStatus.CIVIL_SERVANT,
        },
      ]
    case FormValue.proSituation.UNEMPLOYED:
      return [
        {
          label: i18n.t('freelance_craftperson'),
          value: FormValue.proStatus.TRADER,
        },
        {
          label: i18n.t('business_owner'),
          value: FormValue.proStatus.CEO,
        },
        {
          label: i18n.t('self_employed'),
          value: FormValue.proStatus.SELF_EMPLOYED,
        },
      ]
    // without activity
    default:
      return [
        {
          label: i18n.t('unemployment'),
          value: FormValue.proStatus.BENEFITS,
        },
        {
          label: i18n.t('wellfare'),
          value: FormValue.proStatus.RSA,
        },
        {
          label: i18n.t('no'),
          value: FormValue.proStatus.UNEMPLOYED,
        },
      ]
  }
}
